import styled from "styled-components";

export const CollectorFormModalStyle = styled.div`

`;
